@use '@lib/assets/styles/main.scss' as *;

.conductCodeSectionsContent {
  & > * + * {
    margin-top: 4px;
  }
  & + .conductCodeSectionsContent {
    margin-top: 24px;
  }
}

.conductCodeSectionsBody {
  color: $gray500;
}
